module.exports = __webpack_public_path__ + "img/newicon3.0019a325.png";